import config from '~/config';
import { PriceType } from '~/Domain';

export const roundedHumanFormat = (
	currency: string,
	value: number,
	maximumFractionDigits = 2,
	locale: string[] = config.locale
): string => {
	const options = {
		currency: currency,
		style: 'currency',
		minimumFractionDigits: 2,
		maximumFractionDigits,
		currencyDisplay: 'code',
	};
	try {
		return Intl.NumberFormat(locale, options)
			.format(Number(value))
			.replace(/([A-Z]) ?([0-9])/, '$1\xA0$2');
	} catch {
		return 'N/A';
	}
};

export default class UnitPrice {
	public readonly value: number;

	public readonly currency: string;

	public readonly type: PriceType;

	public readonly physicalUnit: string;

	public constructor(type: PriceType, currency: string, value: number, physicalUnit: string) {
		this.type = type;
		this.value = value;
		this.currency = currency;
		this.physicalUnit = physicalUnit;
	}

	roundedHumanFormat(maximumFractionDigits = 2, locale: string[] = config.locale): string {
		return roundedHumanFormat(this.currency, this.value, maximumFractionDigits, locale);
	}

	roundedHumanFormatWithUnit(maximumFractionDigits = 2, locale: string[] = config.locale): string {
		let formattedPrice = roundedHumanFormat(this.currency, this.value, maximumFractionDigits, locale);

		const parts = formattedPrice.split(' ');
		const prefix = `${parts[0]}/${this.physicalUnit}`;
		formattedPrice = `${prefix} ${parts[1]}`;

		return formattedPrice;
	}

	humanFormat(locale: string[] = config.locale): string {
		return this.roundedHumanFormat(20, locale);
	}

	roundedValue(digits = 2): number {
		return Number(Number(this.value).toFixed(digits));
	}

	equals(other: any): boolean {
		return (
			other instanceof UnitPrice &&
			this.currency === other.currency &&
			this.roundedValue() === other.roundedValue() &&
			this.type === other.type &&
			this.physicalUnit === other.physicalUnit
		);
	}
}
